import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { IRatingViewEnrollment } from '@views/user/configuration/rating-view-setup/interfaces/irating-view-enrollment';

@Injectable({
  providedIn: 'root',
})
export class AgeGradeTemplateEnrollmentService {
  constructor(private data: DataService, private translocoService: TranslocoService) {}

  getBaseTemplateEnrollmentByAgency(
    agencyId: number
  ): Observable<IRatingViewEnrollment[]> {
    return this.data.get(`ageGradeTemplateEnrollment/base/${agencyId}`);
  }

  getCustomTemplateEnrollmentById(
    id: number
  ): Observable<IRatingViewEnrollment[]> {
    return this.data.get(`ageGradeTemplateEnrollment/custom/${id}`);
  }

  saveBaseTemplateEnrollment(request: any): Observable<any> {
    return this.data.post(
      `ageGradeTemplateEnrollment/base-templates`,
      request,
      this.translocoService.translate('shared.messages.ratingViewTemplateSaved')
    );
  }

  saveTemplateAssignments(request: any): Observable<any> {
    return this.data.post(`ageGradeTemplateEnrollment/assignments`, request);
  }
}
